import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { ClaimAdjustmentFilterComponent } from '../claim-adjustment-filter/claim-adjustment-filter.component';
import { ListService } from '../../../../shared/services/list.service';
import { UserService } from '../../../../services/user.service';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { ViewTimesheetsComponent } from '../view-timesheets/view-timesheets.component';
import {
  DialogConfig,
  DialogService,
} from '../../../../shared/services/dialog.service';
import { AdjustServiceClaimComponent } from '../adjust-service-claim/adjust-service-claim.component';

@Component({
  selector: 'ppl-claim-adjustment',
  standalone: true,
  imports: [
    ListTableComponent,
    ClaimAdjustmentFilterComponent,
    ViewTimesheetsComponent,
    AdjustServiceClaimComponent,
  ],
  templateUrl: './claim-adjustment.component.html',
  styleUrl: './claim-adjustment.component.css',
})
export class ClaimAdjustmentComponent implements OnInit {
  isPageRestrictionLoaded = true;
  claimDetailId: any;
  claimDetails: any;
  serviceAdjustDialog: any;
  actionButtons: TableRowActionsModel = new TableRowActions({
    viewTimesheets: true,
    adjustService: true,
    adjustMCO: true,
  });
  @ViewChild('viewTimesheetsDialog') viewTimesheetsDialog!: TemplateRef<any>;
  @ViewChild('adjustServiceClaimDialog')
  adjustServiceClaimDialog!: TemplateRef<any>;
  @ViewChild('adjustMCODialog') adjustMCODialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  buttonConfig = [
    {
      key: 'viewTimesheets',
      label: 'View Timesheets',
      icon: '',
      disabled: (rowData: any) => false,
      condition: (rowData: any) => this.actionButtons?.viewTimesheets,
    },
    {
      key: 'adjustService',
      label: 'Service Adjust',
      icon: '',
      disabled: (rowData: any) => !rowData?.paidTimesheet,
      condition: (rowData: any) => this.actionButtons?.adjustService,
    },
    {
      key: 'adjustMCO',
      label: 'MCO/Auth Adjust',
      icon: '',
      disabled: (rowData: any) => !rowData?.paidTimesheet,
      condition: (rowData: any) => this.actionButtons?.adjustMCO,
    },
  ];

  claimsData: any[] = [];
  cols = [
    {
      field: 'participantPplId',
      header: 'Consumer PPL ID',
      jsonpath: 'participantPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true,
    },
    {
      field: 'mcoName',
      header: 'MCO Name',
      jsonpath: 'mcoName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'pplIcn',
      header: 'PPL ICN',
      jsonpath: 'pplIcn',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceCodeDescription',
      header: 'Service Description',
      jsonpath: 'serviceCodeDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'modifierCode',
      header: 'Modifier Code',
      jsonpath: 'modifierCode',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'authNumber',
      header: 'Auth Number',
      jsonpath: 'authNumber',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDate',
      header: 'Service Date',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'units',
      header: 'Units',
      jsonpath: 'units',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timesheetsCount',
      header: 'Timesheets Count',
      jsonpath: 'timesheetsCount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billableRate',
      header: 'Service Code Rate',
      jsonpath: 'billableRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'totalCharges',
      header: 'Total Charges',
      jsonpath: 'totalCharges',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paymentAmount',
      header: 'Payment Amount',
      jsonpath: 'paymentAmount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paymentDate',
      header: 'Payment Date',
      jsonpath: 'paymentDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'extIcn',
      header: 'Ext ICN',
      jsonpath: 'extIcn',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'statusDescription',
      header: 'Status',
      jsonpath: 'statusDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];
  appliedFilters: any;
  programName: any;
  fields = [
    { field: 'serviceDate', show: true, default: '' },
    { field: 'serviceCode', show: true, default: '' },
    { field: 'modifierCode', show: false, default: '' },
    { field: 'participantPplId', show: true, default: '' },
    { field: 'pplIcn', show: true, default: '' },
    { field: 'authNumber', show: true, default: '' },
    { field: 'mco', show: true, default: '' },
  ];

  constructor(
    private listService: ListService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
  }

  onPageLoad(event: any) {}

  rowClicked(event: any) {}

  openDialog(
    template: TemplateRef<any>,
    title: string,
    styleClass: string,
    size: any
  ): void {
    const dialogConfig: DialogConfig = {
      title,
      isOkText: 'Ok',
      size: size,
      position: 'top',
      showClose: true,
      showButtons: false,
      styleClass: styleClass,
    };

    this.serviceAdjustDialog = this.dialogSvc.openDialog(
      template,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  cancel(event: any) {
    if (event === 'edited') {
      this.searchClaimData([]);
    } else {
      this.dialogSvc.closeDialog(this.serviceAdjustDialog);
    }
  }

  handleCancel() {}

  rowActions(event: any) {
    if (event.action === 'viewTimesheets') {
      this.claimDetailId = event.data.batchClaimDetailId;
      this.openDialog(
        this.viewTimesheetsDialog,
        'Timesheets',
        'split-auth-data',
        'x-large'
      );
    }
    if (event.action === 'adjustMCO') {
      this.claimDetails = event.data;
      this.openDialog(this.adjustMCODialog, 'MCO/Auth Adjust', '', 'large');
    }
    if (event.action === 'adjustService') {
      this.claimDetails = event.data;
      this.openDialog(
        this.adjustServiceClaimDialog,
        'Service Adjust',
        '',
        'large'
      );
    }
  }

  onSearch(filters: any) {
    this.appliedFilters = filters;
    this.searchClaimData(filters);
  }

  buildRequestPayload(
    pageName: string,
    orderBy: string,
    searchParams: [],
    startingPageNumber = 1
  ) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchClaimData(filters: any) {
    const processedPayload = this.buildRequestPayload(
      'billingClaimsAdjListView',
      'createdDate',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claimadj')
      .subscribe((data: any) => {
        this.claimsData = data.responsedata;
      });
  }
}
